<script>
import './ticket-priority-badge.css';

/**
 * Jira-style priority chip shared by board cards and desk ticket list.
 */
export default {
    name: 'TicketPriorityBadge',
    props: {
        priority: { type: [String, Number], default: '' },
        priorityLabel: { type: String, default: '' },
        /** sm for compact desk sidebar rows */
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['md', 'sm'].includes(value),
        },
        testId: { type: String, default: 'ticket-priority-badge' },
    },
    computed: {
        label() {
            return this.priorityLabel || this.priority || '';
        },
        tone() {
            const raw = String(this.label || this.priority || '').toLowerCase();
            if (raw.includes('alt') || raw === 'high' || raw === '1' || raw === 'urgent') {
                return 'high';
            }
            if (raw.includes('med') || raw === 'medium' || raw === '2' || raw === 'normal') {
                return 'medium';
            }
            return 'low';
        },
        icon() {
            if (this.tone === 'high') {
                return '▲▲';
            }
            if (this.tone === 'medium') {
                return '=';
            }
            return '▼▼';
        },
        rootClass() {
            return [
                'ticket-priority-badge',
                `ticket-priority-badge--${this.tone}`,
                this.size === 'sm' ? 'ticket-priority-badge--sm' : null,
            ];
        },
    },
};
</script>

<template>
    <span
        v-if="label"
        :class="rootClass"
        :data-testid="testId"
    >
        <span
            class="ticket-priority-badge__icon"
            role="img"
            :aria-label="'Priorità ' + String(label).toLowerCase()"
        >{{ icon }}</span>
        {{ label }}
    </span>
</template>
